import { inject, observer } from 'mobx-react';
import React from 'react';
import DatePicker from 'react-datepicker';
import { format, isValid, toDate } from "date-fns";
import moment from 'moment';
import ReleaseIncidentDataStore from '../store/release-incident-store';
@inject('ReleaseIncidentDataStore')
@observer
class ApprovedOnComponent extends React.Component {
  constructor(props) {
    super(props);
    var d = this.props.ReleaseIncidentDataStore.dateSelection.approvedOn!='' && this.props.ReleaseIncidentDataStore.dateSelection.approvedOn!=null?moment(this.props.ReleaseIncidentDataStore.dateSelection.approvedOn):'';
    
    this.state = {
        approvedOn: this.props.ReleaseIncidentDataStore.dateSelection.approvedOn!='' && this.props.ReleaseIncidentDataStore.dateSelection.approvedOn!='' && this.props.ReleaseIncidentDataStore.dateSelection.approvedOn!==null && d.isValid()?(moment(this.props.ReleaseIncidentDataStore.dateSelection.approvedOn).toDate()):''
    }
  }

  handleDateapprovedOnChange = async(estimes) => {
    let estime = estimes!='' && typeof estimes!='undefined' && estimes!=null?moment(estimes).toDate():'';
    await ReleaseIncidentDataStore.approvedOnUpdate(estime);
    this.setState(state => ({
        approvedOn: (estime!='' && typeof estime!='undefined' && estime!==null?estime:''),
    }))
  }

  render() {
    var {dateSelection} = this.props.ReleaseIncidentDataStore;
    
    return(
      <div>
          <DatePicker
              className='form-control'
              selected={this.state.approvedOn!='' && typeof this.state.approvedOn!='undefined' && this.state.approvedOn!==null?this.state.approvedOn:''}
              value={this.state.approvedOn!='' && typeof this.state.approvedOn!='undefined' && this.state.approvedOn!==null?this.state.approvedOn:''}
              shouldCloseOnSelect={false}
              onChange={(etime)=>this.handleDateapprovedOnChange(etime)}
              showTimeInput
              timeInputLabel="Time:"
              dateFormat="MM-dd-yyy HH:mm"
              readOnly={true}
              //readOnly={this.props.isDisabled?true:false}
              //timeFormat="HH:mm"
          />
      </div>
    )
  }
}

export default ApprovedOnComponent;